<template>
    <div :class="$style.block_container">
        <Typography
            v-if="props.title"
            type="header"
            size="xs"
            :responsive="false"
            semibold
        >
            {{ props.title }}
        </Typography>

        <div :class="config.styles.wrapper">
            <GameCard
                v-for="(game, index) in props.games"
                :key="index"
                :game="game"
                :type="config.type(index)"
                :data-interface-target="`game-number-${index + 1}`"
                :disableMicrodata="props.disableMicrodata"
                responsive
                withBadges
                withScaleOnHover
            />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'

import GameCard from '@/components_new/GameCard/GameCard.vue'
import Typography from '@/components_new/Typography.vue'
import type { ShortGameType } from '@/types'

import randomStyles from './GamePageRandomShelf.module.css'
import recommendedStyles from './GamePageRecommendedShelf.module.css'
import defaultStyles from './GamePageShelf.module.css'

type ShelfType = 'recommended' | 'random' | 'related' | 'default'

const props = defineProps<{
    type?: ShelfType
    games: ShortGameType[] | undefined[]
    title?: string
    disableMicrodata?: boolean
}>()

const config = computed(() => {
    switch (props.type) {
        case 'recommended':
            return {
                styles: recommendedStyles,
                type: (index: number) => {
                    return index < 6 ? 'square' : 'rectangle'
                },
            }
        case 'random':
            return {
                styles: randomStyles,
                type: () => {
                    return 'square' as const
                },
            }
        default:
            return {
                styles: defaultStyles,
                type: () => {
                    return 'rectangle' as const
                },
            }
    }
})
</script>

<style module>
.block_container {
    display: grid;
    flex-direction: column;
    gap: 12px;
}
</style>
